<template>
    <div class="loader"></div>
</template>

<script>
    export default {
        name: "Loader"
    }
</script>

<style scoped>
    @keyframes flipper{
        0%{
            transform: perspective(200px) rotate3d(0,1,0,0deg);
            animation-timing-function: ease-out;
        }

        50%{
            transform: perspective(200px) rotate3d(0,1,0,180deg);
            animation-timing-function: ease-out;
        }

        100%{
            transform: perspective(200px) rotate3d(0,1,0,360deg);
            animation-timing-function: ease-in;
        }
    }

    .loader {
        width: 80px;
        height: 80px;

        /* your company logo will go here */
        background-image: url("https://s3.ap-south-1.amazonaws.com/cdn-shebaxyz/sheba_xyz/png/placeholder.png");
        background-size: contain;
        background-position: center;
        animation: flipper 1.5s infinite;
        border-radius: 5px;
        box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
        transition: all 0.3s cubic-bezier(.25,.8,.25,1);
    }
</style>